<template>
  <div>
    <template>
      <div class="titlePage">{{ titlePage }} : {{ pix ? 'Pix' : 'Boleto / GRU' }}</div>
      <div class="row innerPage">
        <div class="col-sm-6">
          <v-select
            :options="lstFormaPagamento"
            v-model="tipopagamento"
            placeholder="Selecione um tipo de pagamento"
            class="selectSPI"
            @input="limpaConta"
            :disabled="
              controlePage.idsituacao === 4 ||
              (!pix && controlePage.contabancaria != null) ||
              (!pix && controlePage.gru != null) ||
              (pix && controlePage.contabancariapix != null)
            "
            :clearable="false"
            label="tipopagamento"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                :required="!tipopagamento"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-select>
        </div>
      </div>
    </template>
    <template v-if="tipopagamento != null && !tipopagamento.grusimples && mostraEtapa">
      <fccEtapa04
        :lstFormaPagamento="lstFormaPagamento"
        :tipopagamento="tipopagamento"
        @alteraTipoPix="alteraTipoPix"
        @alteraTipoPagamento="alteraTipoPagamento"
        :idPublicacao="controlePage.idpublicacao"
        :controlePage="controlePage"
        :pix="pix"
      ></fccEtapa04
    ></template>
    <template v-if="tipopagamento != null && tipopagamento.grusimples && mostraEtapa">
      <fccGruSimples
        :lstFormaPagamento="lstFormaPagamento"
        :tipopagamento="tipopagamento"
        @alteraTipoPagamento="alteraTipoPagamento"
        :idPublicacao="controlePage.idpublicacao"
        :controlePage="controlePage"
      ></fccGruSimples>
    </template>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import fccEtapa04 from '../etapas/Etapa04.vue'
import fccGruSimples from '../fccGruSimples/fccGruSimples.vue'
export default {
  data() {
    return {
      titlePage: 'Tipo de conta',
      mostraEtapa: false,
      lstFormaPagamento: [],
      tipopagamento: null,
      teste: ''
    }
  },
  components: { fccEtapa04, fccGruSimples },
  methods: {
    limpaConta() {
      this.$emit('alteraPub', 0, null)
      if (this.tipopagamento != null) {
        this.carregaTexto(this.codeMensagem('C01'))
        this.mostraEtapa = false
        setTimeout(() => {
          this.mostraEtapa = true
          this.carregaTexto()
        }, 500)
      }
    },
    alteraTipoPix(id, contaBancaria) {
      let controlePage = this.controlePage
      controlePage.idContaBancaria =
        this.controlePage.contabancaria != null
          ? this.controlePage.contabancaria.idcontabancaria
          : 0
      controlePage.idContaBancariaPix = id
      controlePage.idGRU = this.controlePage.gru != null ? this.controlePage.gru.idcontabancaria : 0
      controlePage.dsPublicacao = ''
      this.editaTipoPagamento(id, contaBancaria, false, controlePage)
    },
    alteraTipoPagamento(id, contaBancaria, gru = false) {
      let controlePage = this.controlePage
      controlePage.idContaBancaria = gru ? 0 : id
      controlePage.idContaBancariaPix = this.controlePage.idcontabancariapix
      controlePage.idGRU = gru ? id : 0
      controlePage.dsPublicacao = ''
      this.carregaTexto(this.codeMensagem('C01'))
      this.editaTipoPagamento(id, contaBancaria, gru, controlePage)
    },
    editaTipoPagamento(id, contaBancaria, gru, publicacao) {
      axios
        .put(
          this.baseUrlPublicacao + 'Publicacao/AlterarPublicacao',
          publicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.pix
            ? this.$emit('alteraPix', id, contaBancaria, gru)
            : this.$emit('alteraPub', id, contaBancaria, gru)

          if (id == 0) {
            this.tipopagamento = null
          }
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarTipoPagamento() {
      this.carregaTexto(this.codeMensagem('C01'))
      this.listarTipoPagamentoGenerico().then((resposta) => {
        this.lstFormaPagamento = this.pix
          ? resposta.filter((e) => e.tipopagamento.toLowerCase() === 'pix')
          : resposta.filter((e) => e.tipopagamento.toLowerCase() !== 'pix')
        if (this.controlePage.contabancaria != null) {
          this.capturaTipoPagamento('contabancaria')
        }
        if (this.controlePage.gru != null) {
          this.capturaTipoPagamento('gru')
        }
        if (this.pix && this.controlePage.contabancariapix != null) {
          this.capturaTipoPagamento('contabancariapix')
        }
        this.carregaTexto()
      })
    },
    capturaTipoPagamento(tipo) {
      this.tipopagamento = this.lstFormaPagamento.find(
        (element) => element.id === this.controlePage[tipo].idtipopagamento
      )
      this.mostraEtapa = true
    }
  },
  props: {
    controlePage: Object,
    pix: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listarTipoPagamento()
  }
}
</script>
